module.exports = __webpack_public_path__ + "static/media/1022685.87bcb985.jpg";